import React from 'react';

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  sizes?: string;
  className?: string;
  loading?: 'lazy' | 'eager';
}

export default function Image({ 
  src, 
  alt,
  sizes = '100vw',
  className = '',
  loading = 'lazy',
  ...props 
}: ImageProps) {
  // Generate srcSet for responsive images
  const generateSrcSet = (url: string) => {
    const widths = [320, 640, 768, 1024, 1280, 1536];
    return widths
      .map(width => {
        // For Unsplash images, use their built-in resizing
        if (url.includes('unsplash.com')) {
          const resizedUrl = `${url}&w=${width}`;
          return `${resizedUrl} ${width}w`;
        }
        return null;
      })
      .filter(Boolean)
      .join(', ');
  };

  return (
    <img
      src={src}
      alt={alt}
      sizes={sizes}
      srcSet={generateSrcSet(src)}
      loading={loading}
      className={`max-w-full h-auto ${className}`}
      {...props}
    />
  );
}